<template>
  <div>
      <template v-if="type==1">
          <input
                type="text"
                class="input-text"
                :value="defaultTxt"
                @blur="handle"
                :placeholder="selectData.elementDescribe"
            />
      </template>
      <template v-else-if="type==2">
          <input
                type="number"
                class="input-text"
                :value="defaultTxt"
                @blur="handle"
                :placeholder="selectData.elementDescribe"
            />
      </template>
      <template v-else-if="type==3">
          <input
                type="tel"
                class="input-text"
                :value="defaultTxt"
                @blur="handle"
                :placeholder="selectData.elementDescribe"
            />
      </template>

        <i class="iconfont iconfabiaowenzhang"></i>
  </div>
</template>

<script>
export default {
  data() {
    return {
      defaultTxt: "",
    };
  },
  props: ["selectData","parentItem","type"],
  mounted() {
      if(this.selectData.elementValue){
          this.defaultTxt=this.selectData.elementValue;
      }
  },
  methods: {
    handle(e) {
      //输入框失焦回调
      console.log(e.target.value);
      let value = e.target.value;
      if(value==this.defaultTxt)return;
      this.defaultTxt=value;
      let limit=this.inputLimit(value)
      if(limit){
          this.getResult();
      }
    },

    getResult() {
      //选择后回调到父组件
      let value = this.defaultTxt;
      this.selectData.elementValue=value;
      this.$emit("selected", {
        type:1,
        item:this.selectData,
        value: value
      });
    },
    inputLimit(value){

      let result=0;
      let errorMsg="";
      let limit=this.selectData.limit;
      if(!limit)return true;
      let limits=limit.split("_");
      let limitType=limits[0];
      const title=this.parentItem.moduleName;
      const this_name=this.selectData.elementName;
      if (!value) {
          this.$notice.msg(title+'_'+this_name + "尚未填写")
          this.selectData.errorMsg=""
          return false
      }
      value=value.trim();
      if(limitType==="1"){
        result=this.$regulars.isPhone(value) ? 1 : 2;
      }
      else if(limitType==="2"){//姓名
          result=this.$regulars.isName(value) ? 1 : 2;
      }
      else if(limitType==="3"){//邮编
          result=this.$regulars.isZip(value) ? 1 : 2;
      }
      else if(limitType==="4"){//身份证
          result=this.$regulars.issfz(value) ? 1 : 2;
      }
      else if(limitType==="5"){//数字
          result=this.$regulars.isNum(value) ? 1 : 2;
          errorMsg='您在'+title+'_'+this_name+'里输入的内容："'+value+'"有误，只支持纯数字';
      }
      else if(limitType==="6"){//中英文
          result=this.$regulars.isChAndEn(value) ? 1 : 2;
          errorMsg='您在'+title+'_'+this_name+'里输入的内容："'+value+'"有误，只支持中英文，不支持特殊字符';
      }else if(limitType==="10"){//姓名拼音校验
          result=this.$regulars.isNameSpell(value) ? 1 : 2;
          errorMsg='您在'+title+'_'+this_name+'里输入的内容："'+value+'"有误，必须满足两个拼音之间加一个空格';
      }else if(limitType==="11"){//长度校验-最长
          result=value.length>limits[1]?2:1;
          errorMsg='您在'+title+'_'+this_name+'里输入的内容："'+value+'"有误，字符长度不能超过'+limits[1]+"位";
      }else if(limitType==="12"){//长度校验-最端
          result=value.length<limits[1]?2:1;
          errorMsg='您在'+title+'_'+this_name+'里输入的内容："'+value+'"有误，字符长度不能少于'+limits[1]+"位";
      }else if(limitType==="13"){//整数大小校验-最端
          var min=Number(limits[1]);
          var max=Number(limits[2]);
          var len=Number(value);
          if(value && len > min && len < max){
              result=1
          }else{
              result=2;
              errorMsg='您在'+title+'_'+this_name+'里输入的内容："'+value+'"有误，必须为大于"'+min+'"并且小于"'+max+'"的数字';
          }
      }else if(limitType==="14"){//是否正整数
          result=this.$regulars.isPositiveInteger(value) ? 1 : 2;
          errorMsg='您在'+title+'_'+this_name+'里输入的内容："'+value+'"有误，该数值必须是正整数';
      }else if(limitType==="16"){//校验座机号
          result=this.$regulars.isLandline(value) ? 1 : 2;
          errorMsg='您在'+title+'_'+this_name+'里输入的内容："'+value+'"有误，办公电话正确格式为：区号（3-4位）- 电话号码（7-8位）- 分机号（3-4位,没有可省略）';
      }else if(limitType==="18"){//统一社会信用代码-18位，字母和数字
          result=this.$regulars.isNumOrStr(value) ? 1 : 2;
          if(value.length!=18)result=2;
          errorMsg='您在'+title+'_'+this_name+'里输入的内容："'+value+'"有误，社会信用代码正确格式为：18位的数字或字母';
      }

      if (result === 2) {
          var msgs=errorMsg?errorMsg:title+'_'+this_name + "填写有误";
          this.$notice.alert(msgs)
          this.selectData.errorMsg=msgs;
          return false;
      }
      this.selectData.errorMsg=""
      return true;
    }
  },
  watch: {
    selectData(newVal) {
      this.defaultTxt = newVal.elementValue;
    }
  }
};
</script>

<style lang="scss" scoped>


</style>
